import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
var _Users, _Star;
import cn from "classnames";
import { css } from "styled-components";
import { createUrlWithSourceQueryParams } from "@crehana/analytics";
import { useMe } from "@crehana/auth";
import { Users } from "@crehana/icons";
import { Eye, Star } from "@crehana/icons/outline";
import { Clamp, colors, InverseButton, LazyImage, TextLink, TextTag } from "@crehana/ui";
import BookmarkButton from "../components/BookmarkButton";
import { useCoursePreviewContext } from "../../../ReactContexts/CoursePreviewContext";
import useSimpleCourseCardTranslation from "./hooks/useSimpleCourseCardTranslation";
import useSimpleCourseMainCTA from "./hooks/useSimpleCourseMainCTA";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var secondaryMain = colors.secondaryMain,
  baseMain = colors.baseMain;
var SimpleCourseCard = function SimpleCourseCard(_ref) {
  var className = _ref.className,
    isDark = _ref.isDark,
    course = _ref.course,
    enrollmentUrl = _ref.enrollmentUrl,
    disableRedirections = _ref.disableRedirections,
    onEnrollToCourse = _ref.onEnrollToCourse,
    onGoToCourseDashboard = _ref.onGoToCourseDashboard,
    onGoToCourseDetail = _ref.onGoToCourseDetail,
    onGoToCheckout = _ref.onGoToCheckout,
    onGoToPremiumLanding = _ref.onGoToPremiumLanding,
    renderCustomActions = _ref.renderCustomActions,
    premiumLandingUrl = _ref.premiumLandingUrl,
    pageId = _ref.pageId,
    pageType = _ref.pageType,
    temporalAccessDurationLabel = _ref.temporalAccessDurationLabel,
    onlyTrailer = _ref.onlyTrailer,
    source = _ref.source,
    sourceDetail = _ref.sourceDetail,
    _ref$hideMainButton = _ref.hideMainButton,
    hideMainButton = _ref$hideMainButton === void 0 ? false : _ref$hideMainButton,
    _ref$noMinHeight = _ref.noMinHeight,
    noMinHeight = _ref$noMinHeight === void 0 ? false : _ref$noMinHeight,
    onBookmarkChange = _ref.onBookmarkChange,
    shouldTrackSOFEMembership = _ref.shouldTrackSOFEMembership,
    SOFEEnrollmentSource = _ref.SOFEEnrollmentSource;
  var _useCoursePreviewCont = useCoursePreviewContext(),
    openCoursePreview = _useCoursePreviewCont.openCoursePreview;
  var _useSimpleCourseCardT = useSimpleCourseCardTranslation(),
    t = _useSimpleCourseCardT.t;
  var _useMe = useMe(),
    user = _useMe.me;
  var title = course.title,
    promoImage = course.promoImage,
    imagePlaceholder = course.imagePlaceholder,
    courseTag = course.courseTag,
    score = course.score,
    professor = course.professor,
    enrollments = course.enrollments;
  var mainButtonValues = useSimpleCourseMainCTA({
    course: _objectSpread(_objectSpread({}, course), {}, {
      enrollmentUrl: enrollmentUrl || course.enrollmentUrl
    }),
    user: user,
    disableRedirections: disableRedirections,
    onGoToCourseDashboard: onGoToCourseDashboard,
    onEnrollToCourse: onEnrollToCourse,
    onGoToCourseDetail: onGoToCourseDetail,
    source: source,
    sourceDetail: "".concat(sourceDetail ? "".concat(sourceDetail, " - ") : '', "SimpleCourseCard"),
    shouldTrackSOFEMembership: shouldTrackSOFEMembership,
    SOFEEnrollmentSource: SOFEEnrollmentSource
  });
  var onOpenCoursePreview = function onOpenCoursePreview() {
    openCoursePreview({
      course: _objectSpread(_objectSpread({}, course), {}, {
        enrollmentUrl: enrollmentUrl || course.enrollmentUrl
      }),
      isDark: isDark,
      disableRedirections: disableRedirections,
      onGoToCourseDashboard: onGoToCourseDashboard,
      onEnrollToCourse: onEnrollToCourse,
      onGoToCourseDetail: onGoToCourseDetail,
      onGoToCheckout: onGoToCheckout,
      onGoToPremiumLanding: onGoToPremiumLanding,
      renderCustomActions: renderCustomActions,
      premiumLandingUrl: premiumLandingUrl,
      pageId: pageId,
      pageType: pageType,
      temporalAccessDurationLabel: temporalAccessDurationLabel,
      onlyTrailer: onlyTrailer,
      source: source,
      sourceDetail: sourceDetail
    });
  };
  var gotoCourseDetail = function gotoCourseDetail() {
    if (!disableRedirections) {
      var url = createUrlWithSourceQueryParams({
        url: course.url,
        source: source,
        sourceDetail: sourceDetail
      });
      window.location.href = url;
    } else if (onGoToCourseDetail) {
      return onGoToCourseDetail({
        course: course,
        courseId: course.originalId,
        source: source,
        sourceDetail: sourceDetail
      });
    }
  };
  return /*#__PURE__*/_jsxs(_StyledArticle, {
    className: cn('h-full rounded-5 flex flex-col text-white overflow-hidden', {
      'bg-base-main hover:bg-gray-main-dark-mode': isDark,
      'bg-white shadow-1-dp': !isDark
    }, className),
    $_css: noMinHeight ? 'unset' : '324px',
    children: [/*#__PURE__*/_jsxs("section", {
      className: "relative flex-shrink-0 w-full h-160",
      children: [/*#__PURE__*/_jsx(LazyImage, {
        src: promoImage || '',
        placeholder: imagePlaceholder,
        alt: title || '',
        className: "w-full h-full",
        imgClassName: "rounded-t-5 w-full object-cover",
        imgxParams: {
          fit: 'crop',
          h: 160,
          crop: 'faces'
        }
      }), /*#__PURE__*/_jsx(_StyledSection, {
        className: "absolute inset-0 p-8 font-caption",
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex justify-between h-full ".concat(courseTag ? 'flex-col' : 'flex-col-reverse'),
          children: [(courseTag === null || courseTag === void 0 ? void 0 : courseTag.textLabel) && /*#__PURE__*/_jsx(_StyledTextTag, {
            className: "self-start",
            label: courseTag.textLabel,
            $_css2: (courseTag === null || courseTag === void 0 ? void 0 : courseTag.backgroundColor) || secondaryMain,
            $_css3: (courseTag === null || courseTag === void 0 ? void 0 : courseTag.textColor) || baseMain
          }), /*#__PURE__*/_jsxs("footer", {
            className: "flex items-center self-end justify-between w-full",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex items-center",
              children: [_Users || (_Users = /*#__PURE__*/_jsx(Users, {
                size: 16,
                ignoreColor: true,
                className: "mr-4 fill-current"
              })), /*#__PURE__*/_jsxs("span", {
                children: [enrollments, " ", t('SCC_STUDENTS')]
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex items-center",
              children: [_Star || (_Star = /*#__PURE__*/_jsx(Star, {
                size: 16,
                ignoreColor: true,
                className: "mr-4 fill-current text-yellow-main"
              })), /*#__PURE__*/_jsx("span", {
                children: ((score === null || score === void 0 ? void 0 : score.average) || 5).toFixed(1)
              })]
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(_StyledButton, {
        type: "button",
        onClick: onOpenCoursePreview,
        className: "absolute inset-0 flex items-center justify-center w-full h-full opacity-0 cursor-pointer watch-trailer hover:opacity-100 bg-base-main-80",
        children: /*#__PURE__*/_jsx(TextLink, {
          leftIcon: {
            component: Eye,
            size: 24
          },
          className: "text-white hover:text-white",
          children: t('SCC_WATCH_TRAILER')
        })
      })]
    }), /*#__PURE__*/_jsxs("section", {
      className: cn('p-16 flex-1 rounded-b-5 flex flex-col', className),
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-start justify-between",
        children: [/*#__PURE__*/_jsx(Clamp, {
          className: cn('font-subtitle3 min-h-40 block', isDark ? 'text-white' : 'text-base-main', {
            'cursor-pointer': !disableRedirections
          }),
          as: "h6",
          clamp: 2,
          onClick: gotoCourseDetail,
          children: title
        }), /*#__PURE__*/_jsx(BookmarkButton, {
          isDark: isDark,
          course: course,
          isSavedCourse: course.isSavedCourse || false,
          onBookmarkChange: onBookmarkChange,
          colorType: "primary-main",
          source: source,
          sourceDetail: sourceDetail,
          dataTestid: "course-card-".concat(course.originalId)
        })]
      }), professor ? /*#__PURE__*/_jsxs("p", {
        className: "font-body4 mt-8 block ".concat(isDark ? 'text-white' : 'text-base-main'),
        children: [t('SCC_BY'), " ", professor.fullName]
      }) : null, !hideMainButton && mainButtonValues && /*#__PURE__*/_jsx("footer", {
        className: "mt-auto",
        children: /*#__PURE__*/_jsx(InverseButton, _objectSpread({
          size: "s",
          isWhite: isDark,
          full: true
        }, mainButtonValues))
      })]
    })]
  });
};
export default SimpleCourseCard;
var _StyledArticle = /*#__PURE__*/_styled("article").withConfig({
  componentId: "sc-1yixyf-0"
})(["\n        min-height: ", ";\n        transition: ", ";\n      "], function (p) {
  return p.$_css;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition('background-color');
});
var _StyledSection = /*#__PURE__*/_styled("section").withConfig({
  componentId: "sc-1yixyf-1"
})(["\n            background: linear-gradient(\n              0deg,\n              #181b32 0%,\n              rgba(24, 27, 50, 0) 100%\n            );\n          "]);
var _StyledTextTag = /*#__PURE__*/_styled(TextTag).withConfig({
  componentId: "sc-1yixyf-2"
})(["\n                  background-color: ", ";\n                  color: ", ";\n                "], function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
});
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  componentId: "sc-1yixyf-3"
})(["\n            transition: ", ";\n          "], function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition('opacity');
});